import { ArrowForward, Article } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { ExchangeFormField } from "./ExchangeFormField";

export const ExchangeValues = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <Article style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Information")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <ExchangeFormField label={t("Date")} type="date" code="Date" data={dataState} setData={setDataState} />
            <ExchangeFormField label={t("BuyValue")} type="text" code="BuyValue" data={dataState} setData={setDataState} returnFunc={(_, val) => setDataState(prev => ({ ...prev, BuyValue: val.replace(/[^0-9.]/g, '') }))} />
            <ExchangeFormField label={t("SalesValue")} type="text" code="SalesValue" data={dataState} setData={setDataState} returnFunc={(_, val) => setDataState(prev => ({ ...prev, SalesValue: val.replace(/[^0-9.]/g, '') }))} />
          </div>
        }
      />
    </>
  )
}